import { css } from 'styled-components';

/**
 * PLA-8815: the screen-reader-only recipe shared by every Intelligence primitive that carries an
 * assistive-tech-only status (`CardSkeleton`, `GateStepper`, `SegmentedDistributionBar`,
 * `PeriodDelta`). Declared once so a correction to the recipe cannot drift between copies.
 */
export const visuallyHidden = css`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  overflow: hidden;
`;
